const baseStyle = {
  color: `gray.400`,
  fontFamily: `body`,
  fontWeight: `semibold`,
  fontSize: `sm`,
};

const variants = {
  proRikApp: {
    color: 'primary.base',
    fontWeight: 'medium',
  }
}

export const FormLabel = {
  baseStyle,
  variants
};
